import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Row, Col } from "antd";
import { ProjectFilled, PieChartFilled, HomeFilled, FileAddFilled, ReconciliationFilled, WalletFilled, AppstoreFilled  } from '@ant-design/icons'
import { AppContext } from '../util/context';

export const MenuTab = ({location, appProps}) => {
    const {
        isRep,
        StyledDiv,
        handleSignOut
    } = useContext(AppContext);
    const navigate = useNavigate();
    return (
        <>
            <Row
                style={{
                    height: "25%",
                    backgroundColor: "#FFC000",
                    borderBottomRightRadius: "10px",
                }}
            >
                <Col
                    span={24}
                >
                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "50%",
                        }}
                    >
                        <div
                            className="menuContainer"
                            onClick = { () => navigate('/newhome')}
                        >
                            <HomeFilled 
                                className={location === "home" ? "menuTextIconSelected" : "menuTextIcon"}
                            />
                            <StyledDiv
                                className={location === "home" ? "selectedMenuText" : "menuText"}
                                style={{
                                    marginTop: "6px"
                                }}
                            >HOME</StyledDiv>
                        </div>
                        
                    </Row>

                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            height: "50%",

                        }}
                    >
                        <div
                            className="menuContainer"
                            onClick = { () => navigate('/newcard')}
                        >
                            <FileAddFilled
                                className={location === "newcard" ? "menuTextIconSelected" : "menuTextIcon"}
                            />
                            <StyledDiv
                                className={location === "newcard" ? "selectedMenuText" : "menuText"}
                                style={{
                                    marginTop: "6px"
                                }}
                            >NEW OBSERVATION</StyledDiv>
                        </div>
                    </Row>
                </Col>
            </Row>

            <Row
                style={{
                    marginTop: "3dvh",
                    height: "42%",
                    backgroundColor: "#FFC000",
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                }}
            >
                <Col
                    span={24}
                >

                    {isRep && <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            height: "33.3%",

                        }}
                    >
                        <div
                            className="menuContainer"
                            onClick = { () => navigate('/review')}
                        >
                            <ProjectFilled
                                className={location === "review" ? "menuTextIconSelected" : "menuTextIcon"}
                            />
                            <StyledDiv
                                className={location === "review" ? "selectedMenuText" : "menuText"}
                                style={{
                                    marginTop: "6px"
                                }}
                            >QHSSE REVIEW</StyledDiv>
                        </div>
                    </Row>}

                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            height: "33.3%",

                        }}
                    >
                        <div
                            className="menuContainer"
                            onClick = { () => navigate('/actiontracker')}
                        >
                            <ReconciliationFilled
                                className={location === "actiontracker" ? "menuTextIconSelected" : "menuTextIcon"}
                            />
                            <StyledDiv
                                className={location === "actiontracker" ? "selectedMenuText" : "menuText"}
                                style={{
                                    marginTop: "6px"
                                }}
                            >ACTION TRACKER</StyledDiv>
                        </div>
                    </Row>

                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            height: "33.3%",

                        }}
                    >
                        <div
                            className="menuContainer"
                            onClick={() => window.open('https://app.powerbi.com/groups/f12ae0a6-d061-41ef-9482-eed45db3fb4f/reports/41529204-7930-43c9-ad1f-fb8744917cc4/a898f030701bdd1066d0?experience=power-bi', '_blank')}
                            
                        >
                            <PieChartFilled
                                className={location === "reports" ? "menuTextIconSelected" : "menuTextIcon"}
                            />
                            <StyledDiv
                                className={location === "reports" ? "selectedMenuText" : "menuText"}
                                style={{
                                    marginTop: "6px"
                                }}
                            >REPORTS</StyledDiv>
                        </div>
                    </Row>
                </Col>
            </Row>

            <Row
                style={{
                    marginTop: "3dvh",
                    height: "26.4%",
                    backgroundColor: "#FFC000",
                    borderTopRightRadius: "10px",
                }}
            >
                <Col
                    span={24}
                    /* style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "end",
                    }} */
                >

                    <Row
                        style={{
                            height: "50%",
                            display: "flex",
                            justifyContent: "center",

                        }}
                    >
                        {/* <div
                            className="menuContainer"
                            onClick = { () => window.open('https://behaviour.tuckerenergyapps.com', '_blank')}
                        >
                            <AppstoreFilled
                                className={"menuTextIcon"}
                            />
                            <StyledDiv
                                className={"menuText"}
                                style={{
                                    marginTop: "6px"
                                }}
                            >BEHAVIOUR BASED</StyledDiv>
                        </div> */}
                    </Row>
                    
                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            paddingBottom: "10px",
                            height: "50%"
                            
                        }}
                    >
                        <div
                            className="menuContainer"
                            onClick = { () => handleSignOut()}
                        >
                            <WalletFilled
                                className="menuTextIcon"
                            />
                            <StyledDiv
                                className="menuText"
                                style={{
                                    marginTop: "6px",
                                }}
                            >LOGOUT</StyledDiv>
                        </div>
                    </Row>
                </Col>
            </Row>
        </>
    )
}
